import * as cropsApi from '@/api/crops/index';
import store from '@/store';
import * as mt from '@/store/monitoring/mutation-types';
import { MonitoringState } from '@/store/monitoring/types';


export async function cleanup() {
  await store.dispatch(`monitoring/${mt.CLEANUP}`);
}

export async function fetchCropYieldEvolution(cropUuid :string, harvestSeason='SUMMER', cropType='SOY') {
  // @ts-ignore
  const cropState = (store.state.monitoring as MonitoringState).cropYieldEvolutionStatus.get(cropUuid);

  if (!cropState?.startsWith('fetching')) {
    await store.dispatch(`monitoring/${mt.FETCHING_CROP_YIELD_EVOLUTION}`, cropUuid);
    
    try {
      const cropData = (await cropsApi.getCropsYieldEvolution(cropUuid, harvestSeason, cropType)).data;
      await store.dispatch(`monitoring/${mt.FETCH_CROP_YIELD_EVOLUTION}`, { uuid: cropUuid, cropYieldEvolution: cropData });
    } catch (err) {
      await store.dispatch(`monitoring/${mt.FETCH_CROP_FAILURE}`, cropUuid);
    }
  }
}
